import React from 'react'
import PropTypes from 'prop-types'

const CheckmarkIcon = ({ style, width = 45, height = 45 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={width}
    height={height}
    viewBox="0 0 80 80"
  >
    <g fill="#007AFA" fillRule="evenodd">
      <circle cx="40" cy="40" r="40" opacity=".15" />
      <path d="M36.617 52.775l21.466-20.53c.39-.297.584-.706.584-1.227 0-.52-.195-.93-.584-1.227l-2.566-2.566c-.39-.372-.836-.558-1.342-.558-.506 0-.953.186-1.342.558l-17.5 16.736-8.166-7.81c-.39-.372-.836-.558-1.342-.558-.506 0-.953.186-1.342.558l-2.566 2.566c-.39.297-.584.707-.584 1.227 0 .52.195.93.584 1.228L34.05 52.775c.311.372.739.558 1.283.558.545 0 .973-.186 1.284-.558z" />
    </g>
  </svg>
)

CheckmarkIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default CheckmarkIcon
